import { render } from "./CombatCanvas.vue?vue&type=template&id=25aa3db0&ts=true"
import script from "./CombatCanvas.vue?vue&type=script&lang=ts"
export * from "./CombatCanvas.vue?vue&type=script&lang=ts"

import "./CombatCanvas.vue?vue&type=style&index=0&id=25aa3db0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__